import React from 'react'
import {Link} from "react-router-dom";

const side_data = [
    {name: 'Dashboard', id: 'dashboard', icon: require('../assets/dashboard-icon.svg'), link: '/dashboard', mobile: false},
    {name: 'Pay', id: 'make-payment', icon: require('../assets/pay-icon.svg'), link:'/payments', mobile: true},
    {name: 'Activity', id: 'activity', icon: require('../assets/activity-icon.svg'), link:'/activities', mobile: true},
    {name: 'Wallet', id: 'wallet', icon: require('../assets/wallet-icon.svg'), link: '/wallet', mobile: true},
    {name: 'Where to buy', id:'where-to-buy', icon: require('../assets/shopping-basket-icon.svg'), link: '/where-to-buy', mobile: true},
    {name: 'EnjoyNow', id: 'enjoy-now', icon: require('../assets/enjoy_now.svg'), link: '/enjoy-now', mobile: false},
]
export function SideBar() {
    return (
        <div className="fixed bottom-0 left-0 right-0 z-10 md:static h-20 md:h-screen md:overflow-y-auto md:w-20 px-3 bg-k-indigo  md:flex md:flex-col justify-around md:justify-start  md:pt-6">
            <Link className="hidden md:block" to={'/'} >
                <img className="mb-16" alt={""} src={require('../assets/odio-pay-logo-sky-blue.svg')}/>
            </Link>
            <div className="flex-1 md:space-y-8 md:mb-10 grid grid-cols-4 md:block">
                {
                    side_data.map( data => (
                        <Link className={`my-3 md:my-4 mx-3 md:mx-0 flex-col items-center ${data.mobile ? 'flex': 'hidden md:flex'}`} to={data.link} id={data.id} key={data.id}>
                            <img src={data.icon} className="w-6 md:w-8 h-8 mb-2"  alt={""}/>
                            <span className="text-center text-xs text-k5-blue whitespace-no-wrap">{data.name}</span>
                        </Link>
                    ))
                }
            </div>

        </div>
    )
}
